module.exports = __webpack_public_path__ + "img/kukimi.f4c7254d.webp";